<template>
    <div>
        <b-card class="mt-md-1 mt-2">
            <h4 class="mb-0 text-info font-weight-bolder">اطلاعات فاکتور</h4>
            <b-row>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">شماره فاکتور</h5>
                            <h4 class="mb-0">{{ invoiceDetails.number }}
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-info">
                                    <feather-icon size="20" icon="BoxIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">تاریخ ثبت</h5>
                            <h4 class="mb-0">
                                <span>
                                    {{ new Date(invoiceDetails.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(invoiceDetails.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-info">
                                    <feather-icon size="20" icon="CalendarIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">نوع فاکتور</h5>
                            <h4 class="mb-0">{{ type_management(invoiceDetails.type) }}
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="GridIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">تاریخ فاکتور</h5>
                            <h4 class="mb-0">
                                <span v-if="invoiceDetails.date">
                                    {{ new Date(invoiceDetails.date).toLocaleDateString('fa-IR') }}
                                </span>
                                <span v-else>
                                    ثبت نشده
                                </span>
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="CalendarIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">شناسه فاکتور</h5>
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0">
                                    {{
                                        invoiceDetails.externalInvoiceCode ? invoiceDetails.externalInvoiceCode : 'ثبت نشده'
                                    }}
                                </h4>
                            </div>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="ShoppingBagIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">ثبت کننده</h5>
                            <h4 class="mb-0">
                                {{ invoiceDetails.createdBy.firstName + " " + invoiceDetails.createdBy.lastName }}
                            </h4>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="UserIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">مالیات</h5>
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0">
                                    {{ invoiceDetails.tax ?
                                        invoiceDetails.tax.toLocaleString('fa-IR') : 0
                                    }}
                                </h4>
                                <h6 v-if="invoiceDetails.tax" class="mb-0 ml-25">ریال</h6>
                            </div>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="CircleIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">حمل و نقل</h5>
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0">
                                    {{ invoiceDetails.shipping ?
                                        invoiceDetails.shipping.toLocaleString('fa-IR') : 0 }}
                                </h4>
                                <h6 v-if="invoiceDetails.shipping" class="mb-0 ml-25">ریال</h6>
                            </div>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="TruckIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">تخفیف</h5>
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0">
                                    {{ invoiceDetails.discount ?
                                        invoiceDetails.discount.toLocaleString('fa-IR') : 0 }}
                                </h4>
                                <h6 v-if="invoiceDetails.discount" class="mb-0 ml-25">ریال</h6>
                            </div>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="PercentIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col lg="6" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">مبلغ کل</h5>
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0">
                                    {{ invoiceDetails.totalAmount ?
                                        invoiceDetails.totalAmount.toLocaleString('fa-IR')
                                        : 0
                                    }}
                                </h4>
                                <h6 v-if="invoiceDetails.totalAmount" class="mb-0 ml-25">ریال</h6>
                            </div>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="DollarSignIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
                <b-col v-if="invoiceDetails.description" md="12" class="mt-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h5 class="text-secondary">توضیحات فاکتور</h5>
                            <h5 class="mb-0">{{ invoiceDetails.description }}
                            </h5>
                        </div>
                        <b-media no-body>
                            <b-media-aside class="mr-0">
                                <b-avatar rounded size="48" variant="light-secondary">
                                    <feather-icon size="20" icon="FileTextIcon" />
                                </b-avatar>
                            </b-media-aside>
                        </b-media>
                    </div>
                </b-col>
            </b-row>
        </b-card>

        <b-card v-if="invoiceDetails" no-body class="mb-2">
            <b-table responsive :items="invoiceDetails.items" :fields="fields" hover bordered class="mb-0">
                <template #cell(rawMaterial.name)="data">
                    {{ data.item.rawMaterial.name }}
                </template>
                <template #cell(quantity)="data">
                    {{
                        [101, 100].includes(data.item.displayUnit) ? data.item.quantity / 1000 : data.item.quantity
                    }}
                </template>
                <template #cell(displayUnit)="data">
                    {{ displayUnit_management(data.item.displayUnit) }}
                </template>
                <template #cell(unitPrice)="data">
                    {{ ([101, 100].includes(data.item.displayUnit) ? data.item.unitPrice * 1000 :
                        data.item.unitPrice).toLocaleString('fa-IR') }}
                </template>
                <template #cell(totalPrice)="data">
                    {{ data.item.totalPrice.toLocaleString('fa-IR') }}
                </template>
            </b-table>
        </b-card>

    </div>
</template>

<script>
import { BCard, BRow, BCol, BAvatar, BMediaAside, BMedia, BButton, BTable } from 'bootstrap-vue';

export default {
    components: {
        BCard,
        BRow,
        BCol,
        BAvatar,
        BMediaAside,
        BMedia,
        BButton,
        BTable
    },
    data() {
        return {
            fields: [
                {
                    key: 'rawMaterial.name',
                    label: 'ماده اولیه (کالا)',
                },
                {
                    key: 'displayUnit',
                    label: 'واحد اندازه گیری',
                },
                {
                    key: 'quantity',
                    label: 'مقدار',
                },
                {
                    key: 'unitPrice',
                    label: 'فی (ریال)',
                },
                {
                    key: 'totalPrice',
                    label: 'مبلغ کل (ریال)',
                },
            ],
        }
    },
    props: {
        invoiceDetails: {
            type: Object,
            default: () => { },
        },
    },
    computed: {
        type_management() {
            return (status) => {
                if (status == 0) {
                    return 'فاکتور خرید'
                }
                if (status == 1) {
                    return 'فاکتور فروش'
                }
            }
        },
        displayUnit_management() {
            return (status) => {
                if (status == 1) {
                    return 'گرم'
                }
                if (status == 100) {
                    return 'کیلوگرم'
                }
                if (status == 2) {
                    return 'میلی‌لیتر'
                }
                if (status == 101) {
                    return 'لیتر'
                }
                if (status == 3) {
                    return 'عدد'
                }
            }
        },
    },
};
</script>